/**
 * Capability registry — controls which apps may publish/subscribe to which event types.
 * An appId NOT listed here is "bridge-disabled" (all bridge calls silently no-op or warn).
 *
 * Shape per entry:
 *   publish:   string[]  — event types this app is allowed to emit
 *   subscribe: string[]  — event types this app is allowed to listen to
 */
const REGISTRY = {
  // Example:
  // appA: { publish: ["USER_SELECTED"], subscribe: [] },
  // appB: { publish: [], subscribe: ["USER_SELECTED"] },
  // WrapperApp: { publish: ["SUB_APP_LOADED"], subscribe: [] },
  ProductsApp: { publish: ["PRINT_PREVIEW_RENDER"], subscribe: [/*"SUB_APP_LOADED"*/] },
  DashboardApp: { publish: ["PRINT_PREVIEW_RENDER"], subscribe: [/*"SUB_APP_LOADED"*/] },
  HtmlPrintPreviewApp: { publish: [], subscribe: ["PRINT_PREVIEW_RENDER"] },
};


export default REGISTRY;
